var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('clock'),_c('tv-screen-table',{attrs:{"module":_vm.TVScreenStoreModule,"use-list":_vm.useTVScreenList,"module-name":"app-tv-screen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }